// Liens vérifiés de la conversation (fichiers.js) et visionneuse des photos, partagés par le
// rendu Markdown (vignettes des liens recopiés par le modèle), la galerie de photos d'un
// véhicule et l'infobulle des cartes. Valeur par défaut : aucun lien vérifié (toute image du
// Markdown reste bloquée), aucune visionneuse.
import { createContext } from 'react';

export const FichiersContext = createContext({ liens: new Map(), ouvrir: null });
